
import {defineComponent,computed,ref,watch,PropType} from 'vue';
import {KetQuaChiaGio} from '@/models/ketQuaChiaGio';
import {taoLichNhanVien,tongHopNhanVien} from '@/utils/lichNhanVien';
import repository from '@/services/BenhNhanRepository';
import {useToast} from 'primevue/usetoast';
export default defineComponent({
  props:{ketQua:{type:Object as PropType<KetQuaChiaGio>,required:true}},
  emits:['exported'],
  setup(props,{emit}) {
    const selectedId=ref(null as number|null),exporting=ref(false),toast=useToast();
    const rows=computed(()=>taoLichNhanVien(props.ketQua));
    const summary=computed(()=>tongHopNhanVien(props.ketQua));
    const selected=computed(()=>summary.value.find(x=>x.nhanVienId===selectedId.value));
    const details=computed(()=>rows.value.filter(x=>x.nhanVienId===selectedId.value));
    const hour=(s:string)=>s?s.slice(11,16):'';
    const xuat=async()=>{
      const result=props.ketQua,employee=selectedId.value;
      if(exporting.value||!result.lichSuId)return;
      exporting.value=true;
      try {
        const response=await repository.xuatLichNhanVien(result.khoaPhongId,result.lichSuId,employee);
        const url=URL.createObjectURL(response.data),link=document.createElement('a');link.href=url;
        link.download=`LichNhanVien_Khoa${result.khoaPhongId}_Lan${result.lichSuId}_${employee==null?'TatCa':employee}.xlsx`;
        document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);emit('exported');
      } catch(err) {
        const data=err.response?.data;toast.add({severity:'error',summary:'Không xuất được lịch nhân viên',detail:data instanceof Blob?await data.text():data||'Vui lòng thử lại',life:4000});
      } finally{exporting.value=false;}
    };
    watch(()=>props.ketQua,()=>selectedId.value=null);
    return{selectedId,exporting,summary,selected,details,hour,xuat};
  }
});
